import { useTranslation } from 'react-i18next';
import { matchPath, useLocation, useNavigate } from 'react-router-dom';
import { faBars } from '@fortawesome/pro-regular-svg-icons/faBars';
import { faCalendarClock } from '@fortawesome/pro-regular-svg-icons/faCalendarClock';
import { faClipboardList } from '@fortawesome/pro-regular-svg-icons/faClipboardList';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FloatButton, Tooltip } from 'antd';
import ScheduleBoardModal from 'pos-client/components/scheduleBoard/components/ScheduleBoardModal.tsx';
import { useScheduleBoardContext } from 'pos-client/components/scheduleBoard/context/ScheduleBoardContext.tsx';

import './PosFloatMenu.css';

const PosFloatMenu = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { setShowScheduleModal, showScheduleModal } = useScheduleBoardContext();

  const surveyBuilderPath = matchPath(
    {
      path: '/technician-surveys/surveys/:id/*',
    },
    pathname
  );
  if (surveyBuilderPath) {
    return null;
  }

  return (
    <>
      <FloatButton.Group
        trigger="click"
        type="primary"
        className="float-button"
        style={{ right: 24, bottom: 24 }}
        icon={<FontAwesomeIcon icon={faBars} />}
      >
        {pathname !== '/orders/create' && (
          <Tooltip placement="left" title={t('orders.createOrder')}>
            <FloatButton
              icon={<FontAwesomeIcon icon={faClipboardList} />}
              onClick={() => navigate('/orders/create')}
            />
          </Tooltip>
        )}
        {pathname !== '/scheduling' && (
          <Tooltip placement="left" title={t('scheduling.scheduling')}>
            <FloatButton
              icon={
                <FontAwesomeIcon
                  icon={faCalendarClock}
                  onClick={() => setShowScheduleModal(true)}
                />
              }
            />
          </Tooltip>
        )}
      </FloatButton.Group>
      {showScheduleModal && <ScheduleBoardModal />}
    </>
  );
};

export default PosFloatMenu;
